module.exports = __webpack_public_path__ + "img/img_article5_item_2_v2@2x.9df4c4f9.png";